// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.menu-section {
  display: flex;
  gap: 0.5rem;
  justify-content: start;
  flex-direction: column;
  max-width: 600px;
  background-color: rgba(75, 46, 30);
  color: #f5f5f5;
  top: 20%;
  border-radius: 1rem;
  position: absolute;
  padding: 1.6rem;
  
  
}

/* Main Title */
.menu-section h1 {
  font-size: 1.7rem;
  text-align: center;
  letter-spacing: 2px;
}

/* Intro Text */
.menu-section p {
  text-align: center;
  color: #ccc;
  font-weight: bold;
}

/* Section Titles */
.menu-section h2 {
  font-size: 1.2rem;
  padding-bottom: 5px;
}

/* Menu Lists */
.menu-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* Menu Items */
.menu-section li {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  font-size: 1.05rem;
  border-bottom: 1px dashed #333;
}

/* Price Highlight */
.menu-section li span {
  color: #f4c430;
  font-weight: bold;
}

/* Hover Effect */
.menu-section li:hover {
  color: #f4c430;
  transform: translateX(5px);
  transition: all 0.2s ease;
}
.button-menu {
  padding: 14px;
  font-size: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/menu.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;;;AAGjB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,iBAAiB;AACnB","sourcesContent":["\n.menu-section {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: start;\n  flex-direction: column;\n  max-width: 600px;\n  background-color: rgba(75, 46, 30);\n  color: #f5f5f5;\n  top: 20%;\n  border-radius: 1rem;\n  position: absolute;\n  padding: 1.6rem;\n  \n  \n}\n\n/* Main Title */\n.menu-section h1 {\n  font-size: 1.7rem;\n  text-align: center;\n  letter-spacing: 2px;\n}\n\n/* Intro Text */\n.menu-section p {\n  text-align: center;\n  color: #ccc;\n  font-weight: bold;\n}\n\n/* Section Titles */\n.menu-section h2 {\n  font-size: 1.2rem;\n  padding-bottom: 5px;\n}\n\n/* Menu Lists */\n.menu-section ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n/* Menu Items */\n.menu-section li {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 0;\n  font-size: 1.05rem;\n  border-bottom: 1px dashed #333;\n}\n\n/* Price Highlight */\n.menu-section li span {\n  color: #f4c430;\n  font-weight: bold;\n}\n\n/* Hover Effect */\n.menu-section li:hover {\n  color: #f4c430;\n  transform: translateX(5px);\n  transition: all 0.2s ease;\n}\n.button-menu {\n  padding: 14px;\n  font-size: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
